import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { Flex } from '../atom/Layout';
import { Text } from '../atom/Text';

import ThemeStyle from '../../../lib/style/ThemeStyle';

export const Card = ({ img, path, title, content }) => {
  const history = useHistory();

  return (
    <CardConatiner column onClick={() => history.push(path)}>
      <img src={img} width="100%" alt={title} />
      <Flex
        column
        padding="0.313rem 0.438rem"
        alignItems="flex-start"
        width="100%"
        height="3.5rem"
        style={{
          background: ThemeStyle.background.white,
        }}
      >
        <Text size={14} weight="medium">
          {title}
        </Text>
        <Text
          color="caption"
          style={{
            margin: '0.313rem 0 0',
            height: '1.375rem',
          }}
          size={10}
        >
          {content}
        </Text>
      </Flex>
    </CardConatiner>
  );
};

const CardConatiner = styled(Flex)`
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background: ${(props) => props.theme.background.white};
  width: 10.25rem;
  height: 9.25rem;
  justify-content: flex-start;
  cursor: pointer;

  & + & {
    margin-left: 0.438rem;
  }

  img {
    height: 5.5rem;
  }
`;
